export default "__VITE_ASSET__e0de4dd4__"